import { track } from 'utils/tracking';
import type { LoanSearchParams } from '../../helpers/loanSearchParams';

/**
 * The loan details widget's GA4 events (CMS-2063, AirTable #2737 and #2738).
 * A search form rather than a filter, so `form_interact` and not the Sort &
 * Filter panel's `filter_action`.
 */

export type LoanDetailsField = Extract<
  keyof LoanSearchParams,
  'amount' | 'tenure'
>;

const COMPONENT_TITLES: Record<LoanDetailsField, string> = {
  amount: 'Loan Details_Loan Amount',
  tenure: 'Loan Details_Tenure',
};

export function trackLoanDetailsFilled({
  field,
  value,
  componentIndex,
}: {
  field: LoanDetailsField;
  value: string;
  componentIndex: string;
}): void {
  track({
    event: 'form_interact',
    lead_form_name: 'pl-loan-details-form',
    form_type: 'search form',
    action: 'fill',
    component_type: 'textbox',
    component_title: COMPONENT_TITLES[field],
    component_index: componentIndex,
    vertical_code: 'PL',
    form_field_value: value,
  });
}
